module.exports = __webpack_public_path__ + "static/media/presse.22325a07.jpg";